"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EBlogDataQueryOptions = exports.Blog = exports.Footer = exports.Header = exports.Page = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Page extends Base_1.Base {
    name = '';
    urls = [];
    site = '';
    blog_id = '';
    sitemap = null;
    created = null;
    edited = null;
    published = null;
    exclude = false;
    meta = {};
    content = {};
    // jsonld?:any;
    footer_id = '';
    footer = {};
    header_id = '';
    header = {};
    score = null;
    _s = ['urls', 'name', 'blog_id', 'created', 'edited', 'published', 'exclude', 'site', 'score'];
    constructor(data, olMap, type, idLen) {
        super(type || 'pages', idLen || 27);
        (0, Common_1.setObjectProperties)(this, data, olMap, Page);
        this.site = this.site || 'default';
    }
    toDeploymentJSON() {
        let r = this.toJSON();
        delete r.content;
        return r;
    }
    async toSearchJSON() {
        let r = await super.toSearchJSON();
        delete r.content;
        return r;
    }
    async save(parent) {
        if (!this.id) {
            this.setID();
        }
        if (parent && parent._docRef) {
            this._docRef = parent._docRef.collection('cms').doc('root').collection(this._type).doc(this.id);
        }
        if (!this._docRef) {
            throw `Cannot save! No document reference.`;
        }
        else {
            if (!this.created) {
                this.created = Date.now();
            }
            return super.save();
        }
    }
}
exports.Page = Page;
class Header extends Page {
    constructor(data, olMap) {
        super(data, olMap, 'headers', 7);
        (0, Common_1.setObjectProperties)(this, data, olMap, Header);
    }
}
exports.Header = Header;
class Footer extends Page {
    constructor(data, olMap) {
        super(data, olMap, 'footers', 7);
        (0, Common_1.setObjectProperties)(this, data, olMap, Footer);
    }
}
exports.Footer = Footer;
class Blog extends Base_1.Base {
    name = '';
    description = '';
    tags = [];
    entries;
    constructor(data, olMap) {
        super('blogs', 7);
        (0, Common_1.setObjectProperties)(this, data, olMap, Blog);
    }
}
exports.Blog = Blog;
var EBlogDataQueryOptions;
(function (EBlogDataQueryOptions) {
    EBlogDataQueryOptions["LATEST"] = "latest";
    EBlogDataQueryOptions["NEXT_OLDER"] = "older";
    EBlogDataQueryOptions["NEXT_NEWER"] = "newer";
})(EBlogDataQueryOptions || (exports.EBlogDataQueryOptions = EBlogDataQueryOptions = {}));
index_1.olm.pages = (ref, map) => {
    return new Page(ref, map);
};
index_1.olm.headers = (ref, map) => {
    return new Header(ref, map);
};
index_1.olm.footers = (ref, map) => {
    return new Footer(ref, map);
};
index_1.olm.blogs = (ref, map) => {
    return new Blog(ref, map);
};
